export default {
  properties: {
    collapsed: {
      type: 'boolean'
    },
    i18n: {
      type: 'boolean'
    }
  }
};